import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Sheet, Snackbar, Avatar, styled, Typography, Switch, Chip } from '@mui/joy';
import { DialogTitle, Modal, ModalClose, ModalDialog, ModalOverflow, DialogContent, Divider } from '@mui/joy';
import { Stack, FormControl, FormLabel, Input, FormHelperText, Checkbox } from '@mui/joy';
import { Report } from '@mui/icons-material';
import SvgIcon from '@mui/joy/SvgIcon';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

//@ts-ignore
import '../../styles/navigation.scss';
//@ts-ignore
import '../../styles/stage.scss';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAppStore, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { useAuth } from '../../context/authContext';

import ReplyKitPopup from '../Reply Kit/ReplyKitPopup';
import ReplyAutomationsPopup from '../Reply Kit/ReplyAutomationsPopup';
import AutomationsLogPopup from '../Reply Kit/AutomationsLogPopup';

const networking = require('../../Networking/API');
const appsNetworking = require('../../Networking/Apps/AppsAPI');
const replykitNetworking = require('../../Networking/Reply Kit/ReplykitAPI');
const helper = require('../../Helpers/helpers');

function AppSettingsComponent(app: any, subscription: any) {
    const { token } = useAuth();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [tempImage, setTempImage] = useState(null);
    const [keyFileName, setKeyFileName] = useState(null);
    const [key, setKey] = useState(null);
    const [json, setJson] = useState(null);
    const [iconURL, setIconURL] = useState(app.app.icon);
    const [showConnectAppstore, setShowConnectAppstore] = useState(false);
    const [showConnectPlaystore, setShowConnectPlaystore] = useState(false);
    const [packageId, setPackageId] = useState(null);
    const [appleappId, setAppleappId] = useState(null);
    const [appGalleryId, setAppGalleryId] = useState(null);
    const [notificationEmail, setNotificationEmail] = useState(app.app.notification_email ? app.app.notification_email : app.subscription.email);

    const [showReplyKitModal, setShowReplyKitModal] = useState(false);
    const [totalReplies, setTotalReplies] = useState(0);

    const [showAutomationsModal, setShowAutomationsModal] = useState(false);
    const [totalAutomations, setTotalAutomations] = useState(0);

    const [showAutomationsLogModal, setShowAutomationsLogModal] = useState(false);
    const [showAdditionalCountriesModal, setShowAdditionalCountriesModal] = useState(false);

    const currentApp = JSON.parse(localStorage.getItem("currentApp")!);

    // Estados para países adicionais
    const [availableCountries, setAvailableCountries] = useState<any[]>([]);
    const [selectedAdditionalCountries, setSelectedAdditionalCountries] = useState<string[]>(currentApp.additional_countries || []);
    var notification = currentApp.notify_email;
    var daily_notification = currentApp.notify_daily_email;
    var appstore_connected = currentApp.appstore_connect;
    var playstore_connected = currentApp.playstore_connect;

    const huaweiIcon = <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
        <path fill="#e53935" d="M15,6h18c4.971,0,9,4.029,9,9v18c0,4.971-4.029,9-9,9H15c-4.971,0-9-4.029-9-9V15 C6,10.029,10.029,6,15,6z"></path><path fill="#fff" d="M21.775,20.935c-1.506,0-2.669,1.312-2.669,3.716c0,1.571,2.378,5.599,4.486,9.127 C23.592,24.644,23.368,23.655,21.775,20.935z"></path><path fill="#fff" d="M26.225,20.935c-1.624,2.674-1.817,3.711-1.817,12.846c2.108-3.528,4.486-7.558,4.486-9.13 C28.894,22.245,27.731,20.935,26.225,20.935z"></path><path fill="#fff" d="M16.581,23.904c-2.21,1.543-1.484,5.192-0.369,6.386c0.735,0.771,3.596,2.159,6.305,4 L16.581,23.904z"></path><path fill="#fff" d="M31.419,23.904l-5.936,10.385c2.709-1.84,5.57-3.229,6.305-4 C32.903,29.096,33.629,25.447,31.419,23.904z"></path><path fill="#fff" d="M13.612,29.84c0.036,4.111,2.545,5.191,4.241,5.191h4.241L13.612,29.84z"></path><path fill="#fff" d="M34.388,29.84l-8.483,5.191h4.241C31.843,35.031,34.352,33.951,34.388,29.84z"></path><path fill="#fff" d="M15.926,35.775C16.163,37.002,16.698,38,18.239,38c1.542,0,3.035-0.889,3.855-2.225H15.926z"></path><path fill="#fff" d="M25.905,35.775C26.726,37.111,28.219,38,29.761,38s2.076-0.998,2.314-2.225H25.905z"></path><circle cx="14.5" cy="10.5" r="1.5" fill="#b71c1c"></circle><circle cx="33.5" cy="10.5" r="1.5" fill="#b71c1c"></circle><path fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" d="M33.5,10.5c0,0-2,5-9.5,5s-9.5-5-9.5-5"></path>
    </svg>

    useEffect(() => {
        if (app.subscription.plan === 'AAA' || app.subscription.plan === 'U') {
            getTotalReplies();
            getTotalAutomations();
        }
        // Buscar países disponíveis
        getAvailableCountries();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getTotalReplies = () => {
        replykitNetworking.getTotalRepliesOnKit(app.app.id, token).then((results: any) => {
            setTotalReplies(results.count);
        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
        });
    }

    const getTotalAutomations = () => {
        replykitNetworking.getTotalReplyAutomationsOnKit(app.app.id, token).then((results: any) => {
            setTotalAutomations(results.count);
        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
        });
    }

    const getAvailableCountries = () => {
        networking.getCountries().then((countries: any[]) => {
            setAvailableCountries(countries);
        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
        });
    }

    const handleCountrySelection = (countryCode: string) => {
        setSelectedAdditionalCountries(prev => {
            if (prev.includes(countryCode)) {
                return prev.filter(code => code !== countryCode);
            } else {
                return [...prev, countryCode];
            }
        });
    }

    const VisuallyHiddenInput = styled('input')`
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        left: 0;
        white-space: nowrap;
        width: 1px;
        `;

    const updateTempImage = (event: any) => {
        event.preventDefault();

        setIconURL('');
        setError('');
        setShowError(false);

        const file = event.target.files[0];

        if ((file.size / 1024 / 1024).toFixed(4) > "1") {
            setError('File size is too large');
            setShowError(true);
        } else {
            setTempImage(file);
            setIconURL(URL.createObjectURL(file));
        }
    }

    const updateFileName = (event: any) => {
        event.preventDefault();

        const file = event.target.files[0];

        helper.base64For(file).then((result: any) => {
            setKey(result);
            setJson(result);
            setKeyFileName(file.name);
        }).catch((error: any) => {
            setError(error.message);
            setShowError(true);
        });
    }

    const updateWeeklyNotification = (event: any) => {
        event.preventDefault();

        var status = !currentApp.notify_email;

        setLoading(true);
        networking.updateNotificationStatus(currentApp.id, status).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            notification = app.notify_email;

        }).catch((error: Error) => {
            window.scrollTo(0, 0)
            setError(error.message);
            setShowError(true);
            setLoading(false);
        });
    }

    const updateDailyNotification = (event: any) => {
        event.preventDefault();

        var status = !currentApp.notify_daily_email;

        setLoading(true);
        networking.updateNotificationStatus(currentApp.id, status, 'daily').then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            notification = app.notify_email;

        }).catch((error: Error) => {
            window.scrollTo(0, 0)
            setError(error.message);
            setShowError(true);
            setLoading(false);
        });
    }

    const updateNotificationEmail = (event: any) => {
        event.preventDefault();

        setLoading(true);
        networking.updateNotificationStatus(currentApp.id, currentApp.notify_email, notificationEmail).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            notification = app.notify_email;

        }).catch((error: Error) => {
            window.scrollTo(0, 0)
            setError(error.message);
            setShowError(true);
            setLoading(false);
        });
    }

    const updateTrendingThreshold = (event: any) => {
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const threshold = formJson.threshold;

        console.log(threshold);

        appsNetworking.updateAppThreshold(currentApp.id, threshold, token).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app));

        }).catch((error: Error) => {
            window.scrollTo(0, 0)
            setError(error.message);
            setShowError(true);
            setLoading(false);
        });
    }

    const handlePackageChange = (event: any) => {
        setError('');
        setPackageId(event.target.value);
    }

    const handleAppGalleryChange = (event: any) => {
        setError('');
        setAppGalleryId(event.target.value);
    }

    const handleAppleIdChange = (event: any) => {
        setError('');
        setAppleappId(event.target.value);
    }

    const updateApp = (event: any) => {
        setLoading(true);

        if (tempImage) {
            currentApp.icon = tempImage;
        }

        if (packageId) {
            currentApp.androidpackageid = packageId
        }

        if (appleappId) {
            currentApp.appleappid = appleappId
        }

        if (appGalleryId) {
            currentApp.app_gallery_id = appGalleryId
        }

        // Incluir países adicionais
        currentApp.additional_countries = selectedAdditionalCountries;

        networking.updateApp(currentApp.id, currentApp, subscription).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);
            setAppleappId(app.app.appleappid);
            setPackageId(app.app.androidpackageid);
            setAppGalleryId(app.app.app_gallery_id);

            localStorage.setItem("currentApp", JSON.stringify(app.app));

        }).catch((error: Error) => {
            window.scrollTo(0, 0);
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    const removeApp = (event: any) => {
        event.preventDefault();

        setLoading(true);
        networking.deleteApp(currentApp.id).then((app: any) => {
            setLoading(false);
            navigate("/apps-list");
        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    const manageAppstoreConnection = (event: any) => {
        if (currentApp.appstore_connect === true) {
            disconnectFromAppstoreConnect();
        } else {
            setKeyFileName(null);
            setShowConnectAppstore(true);
        }
    }

    const managePlaystoreConnection = (event: any) => {
        if (currentApp.playstore_connect === true) {
            disconnectFromPlaystore();
        } else {
            setKeyFileName(null);
            setShowConnectPlaystore(true);
        }
    }

    const connectToAppstoreConnect = (event: any) => {
        setLoading(true);
        setShowConnectAppstore(false);

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        formJson.key = key!
        formJson.connect = currentApp.appstore_connect === true ? 'false' : 'true'

        networking.connectAppstoreConnect(currentApp.id, formJson).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            setShowConnectAppstore(false);

        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    function disconnectFromAppstoreConnect() {
        let data = {
            "key": null,
            "keyid": null,
            "issuerid": null,
            "connect": false
        }

        setLoading(true);
        networking.connectAppstoreConnect(currentApp.id, data).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            setShowConnectAppstore(false);
        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    const connectToPlaystore = (event: any) => {
        setLoading(true);
        setShowConnectPlaystore(false);

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        formJson.androidjsonfile = json!
        formJson.connect = currentApp.playstore_connect === true ? 'false' : 'true'

        networking.connectPlaystore(currentApp.id, formJson).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            setShowConnectPlaystore(false);

        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    function disconnectFromPlaystore() {
        let data = {
            "androidJsonFile": null,
            "androidPackageId": null,
            "androidBucketId": null,
            "connect": false
        }

        setLoading(true);
        networking.connectPlaystore(currentApp.id, data).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            setShowConnectAppstore(false);
        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    const connectToSlack = (event: any) => {
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        networking.connectSlack(currentApp.id, formJson).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            setShowConnectAppstore(false);

        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    const connectToTeams = (event: any) => {
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        networking.connectTeams(currentApp.id, formJson).then((app: any) => {
            setLoading(false);
            setShowSuccess(true);

            localStorage.setItem("currentApp", JSON.stringify(app.app));
            setShowConnectAppstore(false);

        }).catch((error: Error) => {
            setShowError(true);
            setError(error.message);
            setLoading(false);
        });
    }

    const updateRepliesAndAutomations = () => {
        getTotalReplies();
        getTotalAutomations();
    }

    return (
        <>
            {/* Automations Log Modal */}
            <AutomationsLogPopup
                app={app.app}
                subscription={app.subscription}
                showAutomationLogsModal={showAutomationsLogModal}
                onClose={() => setShowAutomationsLogModal(false)}
            />

            {/* Automations Modal */}
            <ReplyAutomationsPopup
                subscription={app.subscription}
                app={app}
                showAutomationsModal={showAutomationsModal}
                onClose={() => setShowAutomationsModal(false)}
                didSaveNewAutomation={updateRepliesAndAutomations}
            />

            {/*Reply Kit Modal*/}
            <ReplyKitPopup
                subscription={app.subscription}
                app={app}
                showReplyKitModal={showReplyKitModal}
                didSaveNewReply={updateRepliesAndAutomations}
                onClose={() => setShowReplyKitModal(false)} />

            {/* Connect Playstore connect modal */}
            < Modal
                open={showConnectPlaystore}
                onClose={() => setShowConnectPlaystore(false)
                }>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="sm"
                        variant="plain">
                        <ModalClose />
                        <DialogTitle>
                            Connect with Google Play Console
                        </DialogTitle>
                        <Divider />
                        <Typography
                            level="body-sm">
                            Connecting Google Play Console with Appinion allows you to:
                            <ul className='mt-1'>
                                <li>Reply to user reviews directly from Appinion.</li>
                                <li>Fetch full review data, including replies.</li>
                            </ul>
                            To connect, follow the instructions in the <Link to='https://docs.appinion.pt/guides/android/api-keys'>documentation</Link>.
                        </Typography>
                        <Divider />
                        <DialogContent>
                            <form
                                onSubmit={(event) => {
                                    connectToPlaystore(event)
                                }}
                            >
                                <Stack
                                    spacing={2}>
                                    <FormControl
                                        sx={{
                                            marginTop: 2
                                        }}>
                                        <FormLabel>Bucket Id</FormLabel>
                                        <Input
                                            // html input attribute
                                            name="androidbucketid"
                                            type="text"
                                            placeholder="Bucket Id"
                                            size='md'
                                            required
                                        />
                                        <FormHelperText>
                                            The Bucket ID is a unique identifier for your Google Cloud Storage bucket where the service account JSON key file is stored.
                                            Refer to the <Link to='https://docs.appinion.pt/guides/android/play-console'>documentation</Link> to find this information.
                                        </FormHelperText>
                                    </FormControl>
                                    <FormControl
                                        sx={{
                                            marginTop: 2
                                        }}>
                                        <FormLabel sx={{ mb: 1 }}>
                                            Service Account Key (.json)
                                        </FormLabel>
                                        <div className='row my-auto p-2 bg-light rounded'>
                                            <div className='col-auto'>
                                                <Button
                                                    component="label"
                                                    role={undefined}
                                                    tabIndex={-1}
                                                    variant="plain"
                                                    color="neutral"
                                                    startDecorator={
                                                        <SvgIcon>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth={1.5}
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                                                />
                                                            </svg>
                                                        </SvgIcon>
                                                    }
                                                >
                                                    Upload key
                                                    <VisuallyHiddenInput
                                                        onChange={updateFileName}
                                                        accept='.json'
                                                        type="file"
                                                        name="key"
                                                    />
                                                </Button>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <Typography
                                                    level="body-sm">
                                                    {keyFileName ?? 'No file selected'}
                                                </Typography>
                                            </div>
                                        </div>
                                    </FormControl>
                                </Stack>
                                <Button
                                    type='submit'
                                    sx={{ mt: 6 /* margin top */ }}>
                                    Connect
                                </Button>
                            </form>
                        </DialogContent>
                    </ModalDialog>
                </ModalOverflow>
            </Modal >
            {/* Connect App Store Connect modal */}
            < Modal
                open={showConnectAppstore}
                onClose={() => setShowConnectAppstore(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="sm"
                        variant="plain"
                        sx={{
                            minWidth: 420
                        }}>
                        <ModalClose />
                        <DialogTitle>
                            Connect with App Store connect
                        </DialogTitle>
                        <Divider />
                        <Typography
                            level="body-sm">
                            Connecting App Store Connect with Appinion allows you to:
                            <ul className='mt-1'>
                                <li>Reply to user reviews directly from Appinion.</li>
                                <li>Fetch full review data, including replies.</li>
                            </ul>
                            To create API keys, follow the instructions in the <Link to='https://docs.appinion.pt/guides/apple/before'>documentation</Link>.

                        </Typography>
                        <Divider />
                        <DialogContent>
                            <form
                                onSubmit={(event) => {
                                    connectToAppstoreConnect(event)
                                }}
                            >
                                <Stack
                                    spacing={2}>
                                    <FormControl
                                        sx={{
                                            marginTop: 2
                                        }}>
                                        <FormLabel>Issuer Id</FormLabel>
                                        <Typography
                                            level="body-xs"
                                            className='mb-2'>
                                            For Individual API keys, leave blank.
                                        </Typography>
                                        <Input
                                            // html input attribute
                                            name="issuerid"
                                            type="text"
                                            placeholder="Issuer Id"
                                            size='md'
                                        />
                                    </FormControl>
                                    <FormControl
                                        sx={{
                                            marginTop: 2
                                        }}>
                                        <FormLabel>Key Id</FormLabel>
                                        <Input
                                            // html input attribute
                                            name="keyid"
                                            type="text"
                                            placeholder="Key Id"
                                            size='md'
                                            required
                                        />
                                    </FormControl>
                                    <FormControl
                                        sx={{
                                            marginTop: 2
                                        }}>
                                        <FormLabel sx={{ mb: 1 }}>
                                            API Key (.p8)
                                        </FormLabel>
                                        <div className='row my-auto p-2 bg-light rounded'>
                                            <div className='col-auto'>
                                                <Button
                                                    component="label"
                                                    role={undefined}
                                                    tabIndex={-1}
                                                    variant="plain"
                                                    color="neutral"
                                                    startDecorator={
                                                        <SvgIcon>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth={1.5}
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                                                />
                                                            </svg>
                                                        </SvgIcon>
                                                    }
                                                >
                                                    Upload key
                                                    <VisuallyHiddenInput
                                                        onChange={updateFileName}
                                                        accept='.p8'
                                                        type="file"
                                                        name="key"
                                                    />
                                                </Button>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <Typography
                                                    level="body-sm">
                                                    {keyFileName ?? 'No file selected'}
                                                </Typography>
                                            </div>
                                        </div>
                                    </FormControl>
                                </Stack>
                                <Button
                                    type='submit'
                                    sx={{ mt: 6 /* margin top */ }}>
                                    Connect
                                </Button>
                            </form>
                        </DialogContent>
                    </ModalDialog>
                </ModalOverflow>
            </Modal >

            {/* Modal para países adicionais */}
            <Modal
                open={showAdditionalCountriesModal}
                onClose={() => setShowAdditionalCountriesModal(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="md"
                        variant="plain"
                        sx={{
                            minWidth: 500,
                            maxWidth: 600
                        }}>
                        <ModalClose />
                        <DialogTitle>
                            Manage additional countries
                        </DialogTitle>
                        <Divider />
                        <Typography
                            level="body-sm"
                            sx={{ mb: 2 }}>
                            Select additional countries to get reviews when connections to the stores are not active.
                            This will allow you to access reviews from these countries through the public API of the stores.
                        </Typography>
                        <DialogContent>
                            <Typography
                                level="body-sm"
                                sx={{ mb: 2, fontWeight: 'bold' }}>
                                Main country: {app.app.country}
                            </Typography>

                            <div>
                                <Typography
                                    level="title-sm"
                                    sx={{ fontSize: '14px', marginBottom: 1 }}>
                                    Select additional countries:
                                </Typography>
                                <div style={{
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    backgroundColor: '#fafafa'
                                }}>
                                    {availableCountries.map((country) => (
                                        <div key={country.code} style={{ marginBottom: '8px' }}>
                                            <Checkbox
                                                checked={selectedAdditionalCountries.includes(country.code)}
                                                onChange={() => handleCountrySelection(country.code)}
                                                label={
                                                    <Typography level="body-sm">
                                                        {country.name} ({country.code})
                                                    </Typography>
                                                }
                                                disabled={country.code === currentApp.countrycode?.toUpperCase()}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <Typography
                                    level="body-xs"
                                    sx={{ fontSize: '12px', marginTop: 1, color: 'neutral.500' }}>
                                    {selectedAdditionalCountries.length > 0 ?
                                        `${selectedAdditionalCountries.length} países selecionados: ${availableCountries.filter(c => selectedAdditionalCountries.includes(c.code)).map(c => c.name).join(', ')}` :
                                        'Nenhum país adicional selecionado'
                                    }
                                </Typography>
                            </div>

                            <div className='row mt-4'>
                                <div className='col-auto'>
                                    <Button
                                        onClick={() => setShowAdditionalCountriesModal(false)}
                                        variant="outlined"
                                        color="neutral">
                                        Close
                                    </Button>
                                </div>
                                <div className='col-auto'>
                                    <Button
                                        onClick={() => {
                                            setShowAdditionalCountriesModal(false);
                                        }}
                                        color="primary">
                                        Confirm
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>
            {
                showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {
                showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    Changes saved.
                </Snackbar>
            }
            {
                loading ?
                    <LoadingSpinnerComponent />
                    :
                    <>
                        <Sheet
                            variant="plain"
                            sx={{
                                p: 3,
                                borderRadius: 12,
                                backgroundColor: 'white',
                                border: '1px solid #E0E0E0'
                            }}>
                            <div className='row my-auto'>
                                <div className='col-auto'>
                                    <Avatar
                                        alt='The App Icon'
                                        src={iconURL}
                                        sx={{ borderRadius: 12 }}>
                                        {helper.getInitials(app.app.name)}
                                    </Avatar>
                                </div>
                                <div className='col-auto my-auto'>
                                    <Typography
                                        level="title-sm">
                                        {app.app.name}
                                    </Typography>
                                    <Typography
                                        level="body-xs"
                                        className='mb-4'>
                                        {app.app.country}
                                    </Typography>
                                </div>
                                <div className='col-auto'>
                                    <Button
                                        component="label"
                                        role={undefined}
                                        tabIndex={-1}
                                        variant="outlined"
                                        color="neutral"
                                        startDecorator={
                                            <SvgIcon>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth={1.5}
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                                    />
                                                </svg>
                                            </SvgIcon>
                                        }
                                    >
                                        Update App Icon
                                        <VisuallyHiddenInput
                                            onChange={updateTempImage}
                                            accept='image/png, image/jpeg'
                                            type="file"
                                            name="avatar"
                                        />
                                    </Button>
                                </div>
                            </div>
                            <Typography
                                sx={{
                                    marginBottom: 1,
                                    marginTop: 2
                                }}
                                level="title-sm">
                                Source App Identifiers
                            </Typography>
                            <Divider className='mb-4' />
                            {app.app.appleappid &&
                                <>
                                    <FormLabel
                                        sx={{ fontSize: '12px' }}>
                                        <span className='me-2'>
                                            <FontAwesomeIcon icon={faAppStore} color='#111111' />
                                        </span>
                                        App ID
                                    </FormLabel>
                                    <Typography
                                        level="body-sm">
                                        {app.app.appleappid}
                                    </Typography>
                                </>
                            }
                            {
                                !app.app.appleappid &&
                                <FormControl
                                    sx={{
                                    }}>
                                    <FormLabel
                                        sx={{ fontSize: '12px' }}>
                                        <span className='me-2'>
                                            <FontAwesomeIcon icon={faAppStore} color='#111111' />
                                        </span>
                                        App ID
                                    </FormLabel>
                                    <Input
                                        // html input attribute
                                        name="appleAppId"
                                        type="text"
                                        placeholder="1234567890"
                                        onChange={handleAppleIdChange}
                                        size='lg'
                                        sx={{ fontSize: '14px' }}
                                    />
                                    <FormHelperText sx={{ fontSize: '12px', fontWeight: 'medium' }}>
                                        The App ID is a unique identifier assigned to your app within Apple's App Store.
                                        It is typically a numeric string (e.g., 1234567890) that you can find in your App Store Connect account.
                                    </FormHelperText>
                                </FormControl>
                            }
                            {app.app.androidpackageid &&
                                <>
                                    <FormLabel
                                        sx={{ fontSize: '12px' }}
                                        className='mt-4'>
                                        <span className='me-2'>
                                            <FontAwesomeIcon icon={faGooglePlay} color='#00C853' />
                                        </span>
                                        Application ID
                                    </FormLabel>
                                    <Typography
                                        level="body-sm">
                                        {app.app.androidpackageid}
                                    </Typography>
                                </>
                            }
                            {
                                !app.app.androidpackageid &&
                                <FormControl
                                    sx={{
                                        marginTop: 2
                                    }}>
                                    <FormLabel
                                        sx={{ fontSize: '12px' }}>
                                        <span className='me-2'>
                                            <FontAwesomeIcon icon={faGooglePlay} color='#00C853' />
                                        </span>
                                        Application ID
                                    </FormLabel>
                                    <Input
                                        // html input attribute
                                        name="androidPackageId"
                                        type="text"
                                        placeholder="com.example.myapp"
                                        size='lg'
                                        sx={{ fontSize: '14px' }}
                                        onChange={handlePackageChange}
                                    />
                                    <FormHelperText sx={{ fontSize: '12px', fontWeight: 'medium' }}>
                                        The Application ID is a unique identifier for your Android app.
                                        It typically follows a reverse domain name notation (e.g., com.example.myapp) and is defined
                                        in your app's build configuration.
                                    </FormHelperText>
                                </FormControl>
                            }
                            {app.app.app_gallery_id &&
                                <>
                                    <FormLabel
                                        sx={{ fontSize: '12px' }}
                                        className='mt-4'>
                                        <span className='me-2'>
                                            {huaweiIcon}
                                        </span>
                                        App Gallery ID
                                    </FormLabel>
                                    <Typography
                                        level="body-sm">
                                        {app.app.app_gallery_id}
                                    </Typography>
                                </>
                            }
                            {
                                !app.app.app_gallery_id &&
                                <FormControl
                                    sx={{
                                        marginTop: 2
                                    }}>
                                    <FormLabel
                                        sx={{ fontSize: '12px' }}>
                                        <span className='me-2'>
                                            {huaweiIcon}
                                        </span>
                                        App Gallery ID
                                    </FormLabel>
                                    <Input
                                        // html input attribute
                                        name="app_gallery_id"
                                        type="text"
                                        placeholder="com.example.myapp"
                                        size='lg'
                                        sx={{ fontSize: '14px' }}
                                        onChange={handleAppGalleryChange}
                                    />
                                    <FormHelperText sx={{ fontSize: '12px', fontWeight: 'medium' }}>
                                        The App Gallery ID is a unique identifier assigned to your app within Huawei's AppGallery.
                                        It usually starts with the letter 'C' followed by a series of numbers (e.g., C1234567890).
                                    </FormHelperText>
                                </FormControl>
                            }

                            {/* Botão para adicionar países adicionais - apenas quando não há conexões ativas */}
                            {(!currentApp.appstore_connect && !currentApp.playstore_connect) && (
                                <>
                                    <Typography
                                        sx={{
                                            marginBottom: 1,
                                            marginTop: 4
                                        }}
                                        level="title-sm">
                                        Additional Countries
                                    </Typography>
                                    <Divider className='mb-3' />
                                    <div className='row'>
                                        <div className='col'>
                                            <Typography
                                                level="body-sm">
                                                Main country: <strong>{app.app.country}</strong>
                                            </Typography>
                                            <Typography
                                                level="body-xs"
                                                sx={{ color: '#666' }}>
                                                {selectedAdditionalCountries.length > 0 ?
                                                    `${selectedAdditionalCountries.length} additional countries selected` :
                                                    'No additional countries selected'
                                                }
                                            </Typography>
                                        </div>
                                        <div className='col-auto my-auto'>
                                            <Button
                                                size='sm'
                                                variant='outlined'
                                                onClick={() => setShowAdditionalCountriesModal(true)}>
                                                Manage Countries
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className='row mt-4'>
                                <div className='col-auto'>
                                    <Button
                                        type='submit'
                                        onClick={(e) => updateApp(e)}>
                                        Save changes
                                    </Button>
                                </div>
                                <div className='col-auto'>
                                    <Button
                                        color='danger'
                                        variant='outlined'
                                        type='submit'
                                        onClick={(e) => removeApp(e)}>
                                        Delete app
                                    </Button>
                                </div>
                            </div>
                        </Sheet>
                        <Typography
                            sx={{
                                marginTop: 4
                            }}
                            level="title-sm">
                            Trending Threshold
                        </Typography>
                        <Typography
                            level="body-sm">
                            Manage how your trending threshold is configured.
                        </Typography>
                        <Sheet
                            variant="plain"
                            sx={{
                                p: 3,
                                borderRadius: 12,
                                backgroundColor: 'white',
                                border: '1px solid #E0E0E0',
                                marginTop: 2
                            }}>
                            <div className='row'>
                                <div className='col'>
                                    <Typography
                                        level="title-sm">
                                        Set your alert threshold
                                    </Typography>
                                    <Typography
                                        level="body-sm"
                                        fontWeight="medium">
                                        Adjust the percentage change in review volume that triggers a trending alert for this app.
                                    </Typography>
                                </div>
                                <div className='col-auto my-auto'>
                                    <form
                                        onSubmit={(event) => {
                                            updateTrendingThreshold(event)
                                        }}>
                                        <div className='row my-auto'>
                                            <div className='col-auto my-auto'>
                                                <FormControl>
                                                    <Input
                                                        name="threshold"
                                                        type="number"
                                                        placeholder=""
                                                        size='lg'
                                                        sx={{
                                                            fontSize: '14px'
                                                        }}
                                                        defaultValue={app.app.trending_threshold}
                                                        slotProps={{
                                                            input: {
                                                                min: 0,
                                                                max: 100
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </div>
                                            <div className='col my-auto mx-2'>
                                                <Typography
                                                    level="body-sm">
                                                    %
                                                </Typography>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <FormControl
                                                    className='my-auto'>
                                                    <Button
                                                        type='submit'
                                                        size='sm'>
                                                        Save
                                                    </Button>
                                                </FormControl>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div >
                        </Sheet >

                        {/* Connections*/}
                        {(app.subscription.plan !== 'A' && app.subscription.plan !== 'AA') &&
                            <>
                                <Typography
                                    sx={{
                                        marginTop: 4
                                    }}
                                    level="title-sm">
                                    Connections
                                </Typography>
                                <Typography
                                    level="body-sm">
                                    Manage your source connections.
                                </Typography>
                                <Sheet
                                    variant="outlined"
                                    sx={{
                                        p: 3,
                                        borderRadius: 12,
                                        backgroundColor: 'white',
                                        border: '1px solid #E0E0E0',
                                        marginTop: 2
                                    }}>
                                    {currentApp.appleappid &&
                                        <div className='row'>
                                            <div className='col'>
                                                <Typography
                                                    level="title-sm">
                                                    App Store Connect
                                                    <span className='ms-2'>
                                                        {
                                                            currentApp.appstore_connect && currentApp.apple_connection_status === true &&
                                                            <Chip
                                                                size='sm'
                                                                color="success">
                                                                Ready
                                                            </Chip>
                                                        }
                                                        {
                                                            currentApp.appstore_connect && currentApp.apple_connection_status === false &&
                                                            <Chip
                                                                size='sm'
                                                                color="danger">
                                                                Not Ready
                                                            </Chip>
                                                        }
                                                    </span>
                                                </Typography>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <Switch
                                                    checked={appstore_connected}
                                                    onChange={() => manageAppstoreConnection(true)}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {currentApp.androidpackageid &&
                                        <div className='row mt-4'>
                                            <div className='col'>
                                                <Typography
                                                    level="title-sm">
                                                    Google Play Console
                                                    <span className='ms-2'>
                                                        {
                                                            currentApp.playstore_connect && currentApp.google_connection_status === true &&
                                                            <Chip
                                                                size='sm'
                                                                color="success">
                                                                Ready
                                                            </Chip>
                                                        }
                                                        {
                                                            currentApp.playstore_connect && currentApp.google_connection_status === false &&
                                                            <Chip
                                                                size='sm'
                                                                color="danger">
                                                                Not Ready
                                                            </Chip>
                                                        }
                                                    </span>
                                                </Typography>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <Switch
                                                    checked={playstore_connected}
                                                    onChange={() => managePlaystoreConnection(true)}
                                                />
                                            </div>
                                        </div>
                                    }
                                </Sheet>
                            </>
                        }

                        {/* Reply Kit*/}
                        {(app.subscription.plan !== 'A' && app.subscription.plan !== 'AA') &&
                            <>
                                <Typography
                                    sx={{
                                        marginTop: 4
                                    }}
                                    level="title-sm">
                                    Reply kit
                                </Typography>
                                <Typography
                                    level="body-sm">
                                    Manage your saved replies to respond faster and more consistently.
                                </Typography>
                                <Sheet
                                    variant="outlined"
                                    sx={{
                                        p: 3,
                                        borderRadius: 12,
                                        backgroundColor: 'white',
                                        border: '1px solid #E0E0E0',
                                        marginTop: 2
                                    }}>
                                    <div className='row'>
                                        <div className='col my-auto'>
                                            <Typography
                                                level="body-sm">
                                                You have <b>{totalReplies}</b> replies on your kit.
                                            </Typography>
                                        </div>
                                        <div className='col-auto my-auto'>
                                            <Button
                                                size='sm'
                                                onClick={() => setShowReplyKitModal(true)}>
                                                Manage Reply Kit
                                            </Button>
                                        </div>
                                    </div>
                                </Sheet>
                                <Typography
                                    sx={{
                                        marginTop: 4
                                    }}
                                    level="title-sm">
                                    Reply automations
                                </Typography>
                                <Typography
                                    level="body-sm">
                                    Manage your reply automations.
                                </Typography>
                                <Sheet
                                    variant="outlined"
                                    sx={{
                                        p: 3,
                                        borderRadius: 12,
                                        backgroundColor: 'white',
                                        border: '1px solid #E0E0E0',
                                        marginTop: 2
                                    }}>
                                    <div className='row'>
                                        <div className='col my-auto'>
                                            <Typography
                                                level='body-sm'>
                                                You have <b>{totalAutomations}</b> reply automations set up.
                                            </Typography>
                                        </div>
                                        <div className='col-auto p-0 my-auto'>
                                            <Button
                                                size='sm'
                                                onClick={() => setShowAutomationsModal(true)}>
                                                Manage Automations
                                            </Button>
                                        </div>
                                        <div className='col-auto my-auto'>
                                            <Button
                                                size='sm'
                                                color='neutral'
                                                sx={{
                                                    background: "#f1f1f1",
                                                    color: "#000000",
                                                    ":hover": { background: "#e5e5e5" }
                                                }}
                                                onClick={() => setShowAutomationsLogModal(true)}>
                                                Check Reply Logs
                                            </Button>
                                        </div>
                                    </div>
                                </Sheet>
                            </>
                        }


                        {/* Integrations and Notifications */}
                        {app.subscription.plan !== 'A' &&
                            <>
                                <Typography
                                    sx={{
                                        marginTop: 4
                                    }}
                                    level="title-sm">
                                    Integrations
                                </Typography>
                                <Typography
                                    level="body-sm">
                                    Manage your sharing integrations.
                                </Typography>
                                <Sheet
                                    variant="outlined"
                                    sx={{
                                        p: 3,
                                        borderRadius: 12,
                                        backgroundColor: 'white',
                                        border: '1px solid #E0E0E0',
                                        marginTop: 2
                                    }}>
                                    <div className='row'>
                                        <div className='col-auto my-auto'>
                                            <Typography
                                                level="title-sm">
                                                Slack
                                            </Typography>
                                            <Typography
                                                level="body-sm">
                                                Connect a webhook to share insights to your slack channel.
                                            </Typography>
                                        </div>
                                        <div className='col my-auto'>
                                            <form
                                                className='row'
                                                onSubmit={(event) => {
                                                    connectToSlack(event)
                                                }}
                                            >
                                                <div className='col my-auto'>
                                                    <FormControl>
                                                        <Input
                                                            // html input attribute
                                                            name="slackwebhook"
                                                            placeholder='Webhook url'
                                                            type="text"
                                                            size='md'
                                                            sx={{
                                                                fontSize: '14px'
                                                            }}
                                                            defaultValue={app.app.slack_webhook_url}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className='col-auto my-auto'>
                                                    <Button
                                                        type='submit'
                                                        size='sm'>
                                                        Save
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className='row mt-4'>
                                        <div className='col-auto my-auto'>
                                            <Typography
                                                level="title-sm">
                                                Microsoft Teams
                                            </Typography>
                                            <Typography
                                                level="body-sm">
                                                Connect a webhook to share insights to your Microsoft Teams channel.
                                            </Typography>
                                        </div>
                                        <div className='col my-auto'>
                                            <form
                                                className='row'
                                                onSubmit={(event) => {
                                                    connectToTeams(event)
                                                }}
                                            >
                                                <div className='col my-auto'>
                                                    <FormControl>
                                                        <Input
                                                            // html input attribute
                                                            name="teamswebhook"
                                                            placeholder='Webhook url'
                                                            type="text"
                                                            size='md'
                                                            sx={{
                                                                fontSize: '14px'
                                                            }}
                                                            defaultValue={app.app.teams_webhook_url}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className='col-auto my-auto'>
                                                    <Button
                                                        type='submit'
                                                        size='sm'>
                                                        Save
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </Sheet>

                                <>
                                    <Typography
                                        sx={{
                                            marginTop: 4,
                                        }}
                                        level="title-sm">
                                        Notifications
                                    </Typography>
                                    <Typography
                                        level="body-sm">
                                        Manage your e-mail notifications.
                                    </Typography>
                                    <Sheet
                                        variant="outlined"
                                        sx={{
                                            p: 3,
                                            borderRadius: 12,
                                            backgroundColor: 'white',
                                            border: '1px solid #E0E0E0',
                                            marginTop: 2
                                        }}>
                                        <div className='row'>
                                            <div className='col'>
                                                <Typography
                                                    level="title-sm">
                                                    Weekly App Pulse
                                                </Typography>
                                                <Typography
                                                    level="body-sm">
                                                    Receive a weekly summary of your app's performance,
                                                    including trends and insights.
                                                </Typography>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <Switch
                                                    checked={notification}
                                                    onChange={(event) => updateWeeklyNotification(event)}
                                                />
                                            </div>
                                        </div>
                                        <Divider className='my-3' />
                                        <div className='row'>
                                            <div className='col'>
                                                <Typography
                                                    level="title-sm">
                                                    Daily reviews
                                                </Typography>
                                                <Typography
                                                    level="body-sm">
                                                    Receive the new reviews for your App.
                                                </Typography>
                                            </div>
                                            <div className='col-auto my-auto'>
                                                <Switch
                                                    checked={daily_notification}
                                                    onChange={(event) => updateDailyNotification(event)}
                                                />
                                            </div>
                                        </div>
                                        <Divider className='my-3' />
                                        {(notification || daily_notification) &&
                                            <div className='row mt-4'>
                                                <div className='col my-auto'>
                                                    <FormControl>
                                                        <FormLabel
                                                            sx={{ fontSize: '12px' }}>
                                                            Email
                                                        </FormLabel>
                                                        <Typography
                                                            level="body-xs"
                                                            sx={{
                                                                fontWeight: 400,
                                                                marginBottom: 2
                                                            }}>
                                                            Choose the email address where notifications will be sent.
                                                        </Typography>
                                                        <Input
                                                            name="notification_email"
                                                            type="email"
                                                            placeholder="Enter your email for notifications"
                                                            size='md'
                                                            required
                                                            defaultValue={notificationEmail}
                                                            onChange={(event) => setNotificationEmail(event.target.value)}
                                                            sx={{ fontSize: '14px' }}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className='col-auto my-auto pt-4'>
                                                    <Button
                                                        onClick={updateNotificationEmail}
                                                        type='submit'
                                                        size='sm'>
                                                        Update
                                                    </Button>
                                                </div>
                                            </div>
                                        }
                                    </Sheet>
                                </>
                            </>
                        }
                    </>
            }
        </>
    );
}

export default AppSettingsComponent;